import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface SenecScreenTemplateProps {
    "data-testid"?: string;
    title?: string;
    content?: ReactNode;
    footer?: ReactNode;
}

export const SenecScreenTemplate = ({ title, content, footer, ...rest }: SenecScreenTemplateProps) => {
    return (
        <Stack
            data-testid={rest["data-testid"]}
            width="100vw"
            minHeight="100vh"
            sx={{ backgroundColor: "neutralGray00.main", p: "1rem" }}
            justifyContent="center"
            alignItems="center"
        >
            <Stack
                width={{ xs: "100%", md: "40%" }}
                minHeight="50vh"
                sx={{
                    backgroundColor: "white.main",
                    border: "1px solid",
                    borderRadius: "12px",
                    borderColor: "neutralGray20.main",
                    textAlign: "center",
                }}
                justifyContent="center"
                alignItems="center"
                spacing={2}
                p="2rem"
            >
                <Stack width="100%" mb="2rem !important" spacing={2}>
                    <SenecLogo />
                    {title && (
                        <Typography variant="h2" m={0}>
                            {title}
                        </Typography>
                    )}
                </Stack>
                {content}
                {footer && (
                    <Stack width="100%" px="2rem" mt="3rem !important">
                        {footer}
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
};

const SenecLogo = () => {
    return (
        <Box>
            <img src="/senec-logo.png" alt="SENEC Logo" height="30px" width="auto" />
        </Box>
    );
};
